import { ApiResponse } from "@/interfaces/api-response";
import { ItemView } from "@/interfaces/common.interface";
import {
  Group,
  Layer,
  Template,
  TemplateType,
} from "@/interfaces/template.interface";
import apiClient, { CustomAxiosRequestConfig } from "@/utils/axios";

const SERVICE_ENDPOINT = "templates";

const createOne = async (data: Partial<Template>) => {
  const response = await apiClient.post<ApiResponse<Template>>(
    `/${SERVICE_ENDPOINT}`,
    data,
  );
  return response.data;
};

const cloneOneById = async (id: string) => {
  const response = await apiClient.post<ApiResponse<Template>>(
    `/${SERVICE_ENDPOINT}/${id}/clone`,
  );
  return response.data;
};

const getMany = async (params: {
  page: number;
  size: number;
  sort?: string;
  search?: string;
  artworkId?: string;
  view?: ItemView;
}) => {
  const response = await apiClient.get<ApiResponse<Template[]>>(`/templates`, {
    params,
  });
  return response.data;
};

const getOneByIdNoToast = async (id: string, params?: object) => {
  try {
    const response = await apiClient.get<ApiResponse<Template>>(
      `/${SERVICE_ENDPOINT}/${id}`,
      { params, hideToast: true } as CustomAxiosRequestConfig,
    );
    return response?.data;
  } catch (error) {
    console.log("Error fetching template by ID:", error);
    return null;
  }
};
const getOneById = async (id: string, params?: object) => {
  const response = await apiClient.get<ApiResponse<Template>>(
    `/${SERVICE_ENDPOINT}/${id}`,
    { params },
  );
  return response?.data;
};
const getGroupsById = async (
  id: string,
  params?: {
    page: number;
    size: number;
    search?: string;
    type?: "print" | "preview";
  },
) => {
  const response = await apiClient.get<ApiResponse<Group[]>>(
    `/${SERVICE_ENDPOINT}/${id}/groups`,
    { params },
  );
  return response?.data;
};

const updateOneById = async (
  id: string,
  data: Partial<Template>,
  params?: object,
) => {
  const response = await apiClient.put<ApiResponse<Template>>(
    `/${SERVICE_ENDPOINT}/${id}`,
    data,
    { params },
  );
  return response.data;
};

const advancedUpdateOneById = async (
  id: string,
  data: Partial<Template>,
  params?: object,
) => {
  const response = await apiClient.put<ApiResponse<Template>>(
    `/${SERVICE_ENDPOINT}/${id}`,
    data,
    { params, version: "v2" } as any,
  );
  return response.data;
};

const updateMany = async (data: Partial<Template>[]) => {
  const response = await apiClient.put<ApiResponse<Template>>(
    `/${SERVICE_ENDPOINT}/update-many`,
    { items: data },
  );
  return response.data;
};

const deleteOneById = async (id: string) => {
  const response = await apiClient.delete<ApiResponse<Template>>(
    `/${SERVICE_ENDPOINT}/${id}`,
  );
  return response.data;
};

const resetOneById = async (id: string) => {
  const response = await apiClient.put<ApiResponse<Template>>(
    `/${SERVICE_ENDPOINT}/${id}/reset`,
  );
  return response.data;
};
const cloneTemplate = async (artworkId: string, templateId: string) => {
  const response = await apiClient.post<Template>(
    `/templates/${templateId}/clone?artworkId=${artworkId}`,
  );
  return response.data;
};
const deleteOne = async (id: string) => {
  const response = await apiClient.delete<ApiResponse<Template>>(
    `/templates/${id}`,
  );
  return response.data;
};

const readManyLayersById = async (
  id: string,
  type: TemplateType,
  params: any,
) => {
  const response = await apiClient.get<ApiResponse<Layer[]>>(
    `/templates/${id}/${type === TemplateType.print ? "print-layers" : "preview-layers"}`,
    {
      params,
    },
  );
  return response.data;
};

const templateApi = {
  createOne,
  cloneOneById,
  getMany,
  getOneById,
  updateOneById,
  advancedUpdateOneById,
  updateMany,
  deleteOneById,
  resetOneById,
  cloneTemplate,
  deleteOne,
  getOneByIdNoToast,
  getGroupsById,
  readManyLayersById,
};
export default templateApi;
